import { createAction } from 'redux-actions';

export const getTransferHistory = createAction(
  'GET_TRANSFER_HISTORY',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getTransferHistorySuccess = createAction('GET_TRANSFER_HISTORY_SUCCESS');
export const getTransferHistoryFailure = createAction('GET_TRANSFER_HISTORY_FAILURE');

export const cancelTransferAction = createAction(
  'CANCEL_TRANSFER_ACTION',
  (payload) => payload,
  (payload, meta) => meta,
);
export const cancelTransferActionSuccess = createAction(
  'CANCEL_TRANSFER_ACTION_SUCCESS',
  (payload) => payload,
  (payload, meta) => meta,
);
export const cancelTransferActionFailure = createAction(
  'CANCEL_TRANSFER_ACTION_FAILURE',
  (payload) => payload,
  (payload, meta) => meta,
);
